module.exports = __webpack_public_path__ + "img/vegetable-purslane-190x100.55cba49a.jpg";